import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { apiService } from "../../services/apiService";
import { API_ENDPOINTS } from "../../services/apiEndpoints";

const BuyerInterests = () => {
  const [buyers, setBuyers] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchBuyerInterests = async () => {
    setLoading(true);
    try {
      const response = await apiService.get(API_ENDPOINTS.BUYERS.INTERESTS_GET);
      setBuyers(response.data || response);
    } catch (error) {
      console.error("Error fetching buyer interests:", error);
      toast.error("Failed to fetch buyer interests");
    } finally {
      setLoading(false);
    }
  };

  const formatInterestValue = (value) => {
    return value
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const renderAllInterestValues = (interestSelection) => {
    if (!interestSelection || !interestSelection.interests) {
      return <span className="text-muted">No interests</span>;
    }
    
    const interests = interestSelection.interests;
    
    const categories = [
      { key: 'tile_size', label: 'TILE SIZE' },
      { key: 'tile_grade', label: 'TILE GRADE' },
      { key: 'sanitary_type', label: 'SANITARY TYPE' },
      { key: 'sanitary_grade', label: 'SANITARY GRADE' },
      { key: 'sanitary_location', label: 'SANITARY LOCATION' }
    ];
    
    return (
      <div className="d-flex flex-column gap-2">
        {categories.map(({ key, label }, index) => {
          const values = interests[key] || [];
          const badgeColors = [
            'bg-secondary text-white'
          ];
          const badgeColor = badgeColors[index % badgeColors.length];
          
          return (
            <div key={key} className="d-flex align-items-center gap-1">
              <span className={`badge ${badgeColor}`}>
                {label}
              </span>
              <span className="text-muted">=</span>
              <div className="d-flex flex-wrap gap-1">
                {values.length > 0 ? (
                  values.map((value, index) => (
                    <span key={index} className="badge bg-light text-dark">
                      {formatInterestValue(value)}
                    </span>
                  ))
                ) : (
                  <span className="text-muted">No data</span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  useEffect(() => {
    fetchBuyerInterests();
  }, []);
  
  if (loading) {
    return (
      <div className="page-header mb-3">
        <div className="row align-items-center">
          <div className="col">
            <h3 className="page-title">Buyer Interests</h3>
          </div>
        </div>
        <div className="text-center py-5">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="page-header mb-3">
        <div className="row align-items-center">
          <div className="col">
            <h3 className="page-title">Buyer Interests</h3>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-header">
          <h4 className="card-title">Buyer Interests</h4>
          <span className="badge bg-primary">Total: {buyers.length}</span>
        </div>
        <div className="card-body">
          {buyers.length === 0 ? (
            <div className="text-center py-4">
              <p className="text-muted">No buyer interests found.</p>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped table-hover">
                 <thead>
                   <tr>
                     <th>Sr.No</th>
                     <th>Buyer Name</th>
                     <th>Mobile Number</th>
                     <th>Interest Values</th>
                     <th>Status</th>
                   </tr>
                 </thead>
                <tbody>
                  {buyers.map((buyer,index) => (
                    <tr key={ index}>
                      <td>{index + 1}</td>
                      <td>
                        <span className="font-monospace">
                          {buyer.buyer_name}
                        </span>
                      </td>
                       <td>{buyer.mobile_number}</td>
                       <td>
                         {renderAllInterestValues(buyer.interest_selection)}
                       </td>
                       <td>
                        {buyer.interest_selection && buyer.interest_selection.interests ? (
                          <span className="badge bg-success">Has Interests</span>
                        ) : (
                          <span className="badge bg-warning">No Interests</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default BuyerInterests;
